<template>
  <div>
    <CustomCallout :has-toggle="true" :border-left-color="statusColor">
      <template #default>
        <div class="row">
          <div class="col-12 col-lg-2 border-right">
            <div
              class="d-flex flex-column h-100 align-items-center justify-content-around"
            >
              <Chip :color="statusColor">
                <span v-text="statusText" />
              </Chip>

              <div>
                <span v-text="requestType" />
              </div>
              <div>
                <span v-text="requestNumber" />
              </div>
            </div>
          </div>

          <div class="col-sm-12 col-md-6 col-lg-8 py-md-3 py-2 pl-md-5 pl-2">
            <div class="row">
              <div class="col-6 col-md-4 d-flex flex-column mb-md-4">
                <CustomInputDisplay
                  label="Estudiante:"
                  label-class="text-gray font-weight-light"
                  :value="studentFullName"
                  class="font-weight-bold"
                />
              </div>

              <div class="col-6 col-md-4 d-flex flex-column mb-md-4">
                <CustomInputDisplay
                  label="Solicitante:"
                  label-class="text-gray font-weight-light"
                  :value="requesterName"
                  class="font-weight-bold"
                />
              </div>

              <div class="col-6 col-md-4 d-flex flex-column mb-md-4">
                <CustomInputDisplay
                  label="Puesto de Solicitante:"
                  label-class="text-gray font-weight-light"
                  :value="requesterPosition"
                  class="font-weight-bold"
                />
              </div>

              <div class="col-6 col-md-3 d-flex flex-column">
                <CustomInputDisplay
                  label="Determinación:"
                  label-class="text-gray font-weight-light"
                  :value="determinationTypeName"
                  class="font-weight-bold"
                />
              </div>

              <div class="col-6 col-md-3 d-flex flex-column">
                <CustomInputDisplay
                  label="Centro/Municipio:"
                  label-class="text-gray font-weight-light"
                  :value="centerMunicipality"
                  class="font-weight-bold"
                />
              </div>

              <div class="col-6 col-md-3 d-flex flex-column">
                <CustomInputDisplay
                  label="Escuela actual del estudiante:"
                  label-class="text-gray font-weight-light"
                  :value="schoolName"
                  class="font-weight-bold"
                />
              </div>
              <div class="col-6 col-md-3 d-flex flex-column">
                <CustomInputDisplay
                  label="Escuela de Consulta:"
                  label-class="text-gray font-weight-light"
                  :value="requestSchoolName"
                  class="font-weight-bold"
                />
              </div>
            </div>
          </div>

          <div class="col-md-2 col-sm-12 d-flex justify-content-end">
            <DropDown class="pt-2 pr-4" :items="getMenuItems()" normal-size />
          </div>
        </div>
      </template>

      <template #edition>
        <div class="additional-container">
          <div class="p2 mt-1">
            <div class="bg-gray p-2">
              <div class="bg-white p-3 rounded pl-c-xl">
                <StatusTimeline :history="model.history" />
              </div>
            </div>
          </div>
        </div>
      </template>
    </CustomCallout>
  </div>
</template>

<script>
import alert from '@/mixin/alert.mixin';
import Chip from './Chip.vue';
import StatusTimeline from './StatusTimeline.vue';
import CustomCallout from 'custom-callout';
import DropDown from 'dropdown';
import CustomInputDisplay from 'CustomInputDisplay';

import {
  tapRequestStatusesEnum,
  determinationTypeEnum,
} from '@/components/pei/ubication-tech-assistance/_types';
import DocumentsService from '@/services/documents';
import {
  getTapRequestRefundReport,
  getTapRequestDirectPayment,
  getTapRequestPurchaseService,
  deleteTapRequest,
} from '@/components/pei/ubication-tech-assistance/search/_api';

export default {
  name: 'ResultRow',
  components: {
    DropDown,
    CustomCallout,
    Chip,
    StatusTimeline,
    CustomInputDisplay,
  },
  mixins: [alert],
  props: {
    value: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {};
  },
  computed: {
    model() {
      return this.value;
    },
    statusColor() {
      return this.model.status?.color || '';
    },
    statusText() {
      return this.model.status?.text || '-';
    },
    studentFullName() {
      return `${this.model.student?.sie}-${this.model.student?.name}` || '-';
    },
    requesterName() {
      return this.model.requester?.name || '-';
    },
    requesterPosition() {
      return this.model.requester?.position || '-';
    },
    requestNumber() {
      return this.model.requestNumber || '-';
    },
    requestType() {
      return this.model.requestType || '-';
    },
    determinationTypeName() {
      return this.model.determinationTypeName || '-';
    },
    centerMunicipality() {
      return (
        `${this.model.location?.center}-${this.model.location?.municipality}` ||
        '-'
      );
    },
    schoolName() {
      return (
        `${this.model.location?.school?.code}-${this.model.location?.school?.name}` ||
        '-'
      );
    },
    requestSchoolName(){
      return this.model.requestSchool || '-';      
    },
    isApproved() {
      return this.model.status?.id === tapRequestStatusesEnum.Aprobado;
    },
    isNew() {
      return this.model.status?.id === tapRequestStatusesEnum.Nuevo;
    },
    isNotified() {
      return this.model.status?.id === tapRequestStatusesEnum.Notificado;
    },
    isAssigned() {
      return this.model.status?.id === tapRequestStatusesEnum.Asignado;
    },
    isApprovedDirectPayment() {
      return (
        (this.isNotified || this.isAssigned) &&
        this.model.determinationType === determinationTypeEnum.PagoDirecto
      );
    },
    isApprovedRefund() {
      return (
        (this.isNotified || this.isAssigned) &&
        this.item?.determinationType === determinationTypeEnum.Reembolso
      );
    },
    isApprovedPurchaseService() {
      return (
        (this.isNotified || this.isAssigned) &&
        this.model.determinationType === determinationTypeEnum.CompraServicio
      );
    },
  },
  methods: {
    getMenuItems() {
      let items = [
        {
          name: 'Entrar',
          icon: 'fas fa-file-import text-green',
          click: () => this.goToRequest(this.model.id),
        },
        {
          name: 'Eliminar',
          icon: 'fas fa-times-circle text-red',
          click: () => this.deleteRequest(this.model.id),
          visible: this.isNew,
        },
        {
          name: 'Descargar Aprobación por Pago Directo',
          icon: 'fas fa-file-import text-green',
          click: () => this.downloadDirectPaymentReport(),
          visible: this.isApprovedDirectPayment,
        },
        {
          name: 'Descargar Aprobación Firmada',
          icon: 'fas fa-file-import text-green',
          click: () => this.getSignedApprovalDocument(),
          visible: this.isNotified && this.model.signedApprovalDocumentId,
        },
        {
          name: 'Descargar Aprobación por Reembolso',
          icon: 'fas fa-file-import text-green',
          click: () => this.downloadRefundReport(),
          visible: this.isApprovedRefund,
        },
        {
          name: 'Descargar Aprobación por Compra de Servicios',
          icon: 'fas fa-file-import text-green',
          click: () => this.downloadPurchaseService(),
          visible: this.isApprovedPurchaseService,
        },
      ];

      return items;
    },
    goToRequest() {
      const tapRequestId = this.model.id;
      this.$router.push({
        name: 'uta-request',
        params: { tapRequestId: tapRequestId },
      });
    },
    async deleteRequest() {
      const tapRequestId = this.model.id;
      const response = await this.ShowCancelModal(
        'Alerta',
        `¿Está seguro que desea eliminar la solicitud?`,
        'Sí',
        'No'
      );
      if (response) {
        this.deleteRow(tapRequestId);
      }
    },
    deleteRow(tapRequestId) {
      let self = this;
      deleteTapRequest(tapRequestId).then(() => {
        self.ShowToast(
          'Aviso',
          'La solicitud ha sido eliminada exitosamente',
          'success'
        );
        this.$emit('onRowDeleted');
      });
    },
    async getSignedApprovalDocument() {
      await DocumentsService.downloadFromServer(
        this.model.signedApprovalDocumentId
      );
    },
    async downloadDirectPaymentReport() {
      const params = {
        requestId: this.model.id,
      };

      await getTapRequestDirectPayment(params).then((response) => {
        DocumentsService.Download(response.data);
      });
    },
    async downloadRefundReport() {
      const params = {
        requestId: this.model.id,
      };

      await getTapRequestRefundReport(params).then((response) => {
        DocumentsService.Download(response.data);
      });
    },
    async downloadPurchaseService() {
      const params = {
        requestId: this.model.id,
      };
      await getTapRequestPurchaseService(params).then((response) => {
        DocumentsService.Download(response.data);
      });
    },
  },
};
</script>
